export const GAME_CATALOG_UPDATED = 'boom/game-catalog/GAME_CATALOG_UPDATED'
export const GAME_CATALOG_CATEGORIES_UPDATED =
  'boom/game-catalog/GAME_CATALOG_CATEGORIES_UPDATED'
export const GAME_CATALOG_SECTIONS_UPDATED =
  'boom/game-catalog/GAME_CATALOG_SECTIONS_UPDATED'
export const GAME_CATALOG_GAMES_UPDATED =
  'boom/game-catalog/GAME_CATALOG_GAMES_UPDATED'
